import { createContext, useContext } from "react";

const ADMIN = { base: "/admin", root: "/admin", publicBase: "/apps", isDev: false };
export const DEV_SPACE = { base: "/dev", root: "/espace-developpeur", publicBase: "/developpeurs/apps", isDev: true };

const SpaceContext = createContext(ADMIN);

export const SpaceProvider = ({ value, children }) => <SpaceContext.Provider value={value}>{children}</SpaceContext.Provider>;

export const useSpace = () => useContext(SpaceContext);
